import React, { useState, useRef } from "react";
import atoms from "../../atoms";
import { useReactToPrint } from "react-to-print";
import { prescriptionProps } from "./inerface";
import moment from "moment";
import constant from "../../../constants/constant";
import { mobileLenByRegion } from "../../../constants/utils";
import molecules from "../../molecules";
import translations from "../../../constants/translations";

const { RegionPhoneSearch, Input, Button } = atoms;
const { PrescriptionCard } = molecules;

const Index = ({
  searchCallBack,
  prescriptionData,
  handleShare,
  handleDownloadPrescription
}: prescriptionProps) => {
  const PdfRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [searchMobileNumberError, setSearchMobileNumberError] = useState(false);
  const eyeType =
    prescriptionData?.contact_lens?.prescription_details?.selectedEyeType;
  const handleSearch = (searchValue: string) => {
    if (searchValue?.length === mobileLenByRegion()) {
      searchCallBack(searchValue);
      setSearchMobileNumberError(false);
    } else {
      setSearchMobileNumberError(true);
    }
  };

  const getPageMargins = () => {
    return `
      @page {
         margin-top: 10mm; 
         margin-right: 10mm; 
         margin-bottom:87mm; 
         margin-left: 10mm; 
         font-size:10px
         size: 210mm 297mm; !important
        } 

        div.page {
            page-break-after: always;
          }

.arabic-only {
  display: none;
}
.english-text {
  display: inline !important;
}
@media print {
  .arabic-only {
    display: inline !important;
  }
  .english-text {
    display: none !important;
  }
}
         `;
  };

  const cssString = getPageMargins();

  return (
    <>
      <div className="w-100">
        <div className="row">
          <div
            className={`col-12 ${prescriptionData?.lens ? "col-sm-8 pe-sm-0" : "col-sm-12"
              } col-md-6 mb-md-0`}
          >
            <div className="">
              <RegionPhoneSearch
                placeholder="Search Mobile Number"
                className="fs-16"
                heading="Search"
                buttonStyle={` ${window.innerWidth > 876 && "w-25"}`}
                setIsOpen={setIsOpen}
                searchCallBack={(searchValue: string) =>
                  handleSearch(searchValue)
                }
              />
            </div>
            {searchMobileNumberError && (
              <p className="p-0 m-0 text-danger fs-12 fw-500">
                {`Mobile Number should be ${mobileLenByRegion()} digit`}
              </p>
            )}
          </div>
          {(prescriptionData?.lens?.prescription_details ||
            prescriptionData?.contact_lens?.prescription_details) && (
              <div
                className={`mt-1 mt-sm-0 col-12 col-sm-4 col-md-6 d-flex gap-3 justify-content-end ps-3 ${window.innerWidth > 768 ? "justify-content-end pe-3" : "ps-3"
                  }`}
              >
                <Button
                  className={`${window.innerWidth < 876 && "outline-button-filter"
                    }`}
                  onClick={() => handleDownloadPrescription()}
                >
                  Download
                </Button>
                <Button
                  className={`d-md-block d-none ${window.innerWidth < 876 && "outline-button-filter"
                    }`}
                  onClick={() => handleShare()}
                >
                  Share
                </Button>
              </div>
            )}
        </div>
        <div ref={PdfRef} className="w-100">
          <style>{cssString}</style>
          {prescriptionData?.lens?.prescription_details && (
            <PrescriptionCard
              lens={prescriptionData?.lens}
              title="Lens"
              eyeType={eyeType}
              arabic_title={translations.Lens}
            />
          )}
          {prescriptionData?.contact_lens?.prescription_details && (
            <div className="pb-1" style={{ marginTop: "6rem" }}>
              <PrescriptionCard
                lens={prescriptionData?.contact_lens}
                title="Contact Lens"
                isContactLens={true}
                eyeType={eyeType}
              arabic_title={translations.Contact_Lens}
              />
            </div>
          )}

          {!(
            prescriptionData?.contact_lens?.prescription_details ||
            prescriptionData?.lens?.prescription_details
          ) && (
              <div className="mt-3 d-flex justify-content-center dark-gray">
                <span>There are no records to display</span>
              </div>
            )}
        </div>
      </div>
    </>
  );
};

export default Index;
